import React from 'react'
import { SegmentedControllerPanel } from '@paypalcorp/pp-react'

export interface ITabPanelProps {
  id: string
  label: string
  mdxType?: string
}

export const TabPanel: React.FC<ITabPanelProps> = ({
  id,
  children,
  label,
  mdxType,
}) => {
  return (
    <SegmentedControllerPanel id={id} tabId={`tab-${id}`}>
      {children}
    </SegmentedControllerPanel>
  )
}
